import React, { useState, useEffect } from 'react';
import { imageHelp } from '../../components/image-router';
import FrameImage from '../../components/frameImage';
import { person } from '../../components/image-router';
import { groupMoney } from '../../components/image-router';
import { volunteerDonation } from '../../components/image-router'
import { polygon } from '../../components/image-router';
import { things } from '../../components/image-router';
import './howHelp.scss';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import useLocalizedNavigate from "../../hooks/useLocalizedNavigate";
import { useTranslation } from 'react-i18next';

const HowHelp = () => {
    const [showThings, setShowThings] = useState(false);
    const [showMoney, setShowMoney] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const navigate = useLocalizedNavigate();
    const { t } = useTranslation();

    const handleButton = () => {
        window.open("https://www.paypal.com/donate/?hosted_button_id=NP4DH8ZJ2XJKU", '_blank', 'noopener,noreferrer');
    };

    const handleLogo = () => {
            navigate("/volunteerForm");
    };

    const handleChange = (value) => {
        switch (value) {
            case 'cosas': setShowThings(!showThings);
                setShowMoney(false);
                setShowForm(false);
                break;
            case 'money': setShowMoney(!showMoney);
                setShowThings(false);
                setShowForm(false);
                break;
            case 'form': setShowForm(!showForm);
                setShowThings(false);
                setShowMoney(false);
                break;
        }

    }

    useEffect(() => {
        window.scrollTo(0, 600)
        setShowForm(false);
        setShowThings(false);
        setShowMoney(true);
    }, []);

    return (
        <>
            <div>
                <FrameImage image={imageHelp} section="howHelp" />

            </div>
            <div className='containerHelpInfo'>
                <div >
                    <div className='helpSubtitle'>
                        {t('howHelp.helpUsHelp')}
                    </div>
                    <div className='participationText'>
                        {t('howHelp.participate3Ways')}
                    </div>
                </div>
                <div className="container">
                    <div className="marginRight">
                        <div className="purpleCircle">
                            <div className="aligner">
                                <img src={person} alt="person" className="imgResize" />
                            </div>
                        </div>
                        <div className='buttonTitle'>
                            {t('howHelp.volunteering')}
                        </div>
                        <div className='buttonDescription'>
                            {t('howHelp.volunteeringDesc')}
                        </div>
                        <div>
                            <button className='buttonYellow' onClick={handleLogo}>{t('howHelp.beVolunteer')}</button>
                        </div>
                    </div>
                    <div className="marginRight">
                        <div className="purpleCircle">
                            <div className="aligner">
                                <img src={groupMoney} alt="person" className="imgResize2 " />
                            </div>
                        </div>
                        <div className='buttonTitle'>
                            {t('howHelp.money')}
                        </div>
                        <div className='buttonDescription'>
                            {t('howHelp.moneyDesc')}
                        </div>
                        <div>
                            <button className='buttonYellow' onClick={() => handleChange('money')}>{t('howHelp.donate')}</button>
                        </div>
                    </div>
                    <div>
                        <div className="purpleCircle">
                            <div className="aligner">
                                <img src={things} alt="person" className="imgResize3" />
                            </div>
                        </div>
                        <div className='buttonTitle'>
                            {t('howHelp.things')}
                        </div>
                        <div className='buttonDescription'>
                            {t('howHelp.thingsDesc')}
                        </div>
                        <div>
                            <button className='buttonYellow' onClick={() => handleChange('cosas')}>{t('howHelp.donate')}</button>
                        </div>
                    </div>
                </div>
                <div className="containerText">
                    <div className="organizationText">
                        {t('howHelp.orgDescription')}
                    </div>
                </div>
                <div  >
                    {showForm ?
                        <div className='FormContainer'>
                            <img src={polygon} alt="Image" className='polygonSize' />
                            <Form>
                                <Row>
                                    <Col sm={12} md={12} lg={12} xl={6} className="text-center">
                                        <h2 className='formMargins formTitle'>{t('howHelp.contactFormTitle')}</h2>
                                        <div className='formMargins'>
                                            <TextField id="outlined-basic" label={t('howHelp.firstName')} variant="outlined" className='inputSize' />
                                        </div>
                                        <div className='formMargins'>
                                            <TextField id="outlined-basic" label={t('howHelp.lastName')} variant="outlined" className='inputSize' />
                                        </div>
                                        <div className='formMargins'>
                                            <TextField id="outlined-basic" label={t('howHelp.phone')} variant="outlined" className='inputSize' />
                                        </div>
                                        <div className='formMargins'>
                                            <TextField id="outlined-basic" label={t('howHelp.email')} variant="outlined" className='inputSize' />
                                        </div>
                                        <div className='formMargins buttonResponsive'>
                                            <Button variant="contained " className='button'>
                                                {t('howHelp.register')}
                                            </Button>
                                        </div>
                                    </Col>
                                    <Col className='hiddenMobile' sm={0} md={0} lg={0} xl={6}>
                                        <div className='classTextfield'>
                                            <TextField
                                                id="outlined-multiline-static"
                                                label={t('howHelp.describeTalents')}
                                                className=''
                                                multiline
                                                minRows={10}
                                                maxRows={10}
                                                defaultValue=""
                                                variant="outlined"
                                                style={{ width: 532, height: 280 }}
                                            />
                                        </div>
                                        <div className='buttonMargin'>
                                            <Button variant="contained " className='button'>
                                                {t('howHelp.register')}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </div> : null}
                </div>
                {showMoney ?
                    <div className='moneyContainer pb-5' >
                        <img src={polygon} alt="Image" className='polygonMoney' />
                        <div className='textThingsStyle'>
                            <div className='mb-lg-2'>
                                {t('howHelp.checkDonation')}
                            </div>
                            <strong>
                                <div className='mb-lg-5 mb-4 mt-4'>
                                    <strong>{t('howHelp.checkOrgName')}</strong>
                                </div>
                                <div className='mb-2'>
                                    <strong>{t('howHelp.checkAddress')}</strong>
                                </div>

                                <div>
                                    <br className='showMobile' />
                                    (937) 387-8373 <br />
                                    (786) 360-3980
                                </div>
                                <div className='hiddenMobile mt-5'>
                                    <b>{t('howHelp.zelle')}</b><br />
                                    <b className='hiddenMobile mb-5'>{t('howHelp.zelleEmail')}</b><br /><br />
                                    <Button className='paypalButton hiddenMobile mt-5' onClick={handleButton}>{t('howHelp.paypal')}</Button>
                                </div>
                            </strong>
                        </div>
                    </div> : null}
                {showThings ?
                    <div className='thingsContainer' >
                        <img src={polygon} alt="Image" className='polygonThings' />
                        <div className='textThingsStyle pt-3'>
                            <p>
                                {t('howHelp.materialDonation')} <br />
                                <div className='hiddenMobile'>
                                    {t('howHelp.schedule')}

                                </div>
                            </p>
                            <br />
                            <p>
                                <strong>
                                    {t('howHelp.thingsAddress')}<br /><br />
                                    (937) 387-8373<br />
                                    (786) 360-3980
                                </strong>
                            </p>
                        </div>
                    </div> : null}
            </div>
            <Row className="quitGutter">
                <Col sm={12} md={12} className="showMobile">
                    <div >
                        <img src={volunteerDonation} className='imgTemp' alt="person" />
                    </div>
                </Col>
                <Col sm={12} md={12} lg={12} xl={6} className='containerLeftInfo2'>
                    <div className='title-content'>
                        {t('howHelp.statsTitle')}
                    </div>
                    <div className='info-content mb-5'>
                        {t('howHelp.statsDescription')}
                    </div>

                </Col>
                <Col lg={6} className='hiddenMobile'>
                    <div >
                        <img src={volunteerDonation} className='imgTemp' alt="person" />
                    </div>
                </Col>
            </Row>

            <div className='frame-home-yellow'>
                <div className='frame-title'>
                    {t('howHelp.moreHelpers')}
                </div>
                <div className='frame-text'>
                    {t('howHelp.alwaysNeedHelp')}
                </div>
            </div>

        </>



    );
}

export default HowHelp;
